// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-classification-inference-save',
//   templateUrl: './classification-inference-save.component.html',
//   styleUrls: ['./classification-inference-save.component.scss'],
// })
// export class ClassificationInferenceSaveComponent  implements OnInit {

//   constructor() { }

//   ngOnInit() {}

// }




import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-classification-inference-save',
  templateUrl: './classification-inference-save.component.html',
  styleUrls: ['./classification-inference-save.component.scss'],
})
export class ClassificationInferenceSaveComponent  implements OnInit {
  @Input() initiator: string = ''; // The component that initiated the modal
  @Input() data: any;
  @Input() result: any;
  @Input() answer: string = ''; // The component that initiated the modal

  list_of_available_answer: string[] = []; // example options

  correct_answer: string = "";

  // constructor(private modalCtrl: ModalController) { }
  constructor(
      private modalCtrl: ModalController,
      private globalService:GlobalService,
      private apiService: ApiService,
    ){}

  ngOnInit() {
    // console.log('PPPPPPPPPPPPPPPPP:', this.data);
    // console.log('RRRRRRRRR:', this.result);
    // console.log('answer:', this.answer);
    this.list_of_available_answer = this.result[0].available_answers || []; // Assuming result contains available answers
  }

  saveAnswer() {
    this.data.answer = this.answer; // Trim whitespace from remarks
    // console.log('AAAanswer:', this.answer);
    // console.log('DDDData before saving:', this.data);

    const question_guid = this.data.guid;
    const question = this.data.question;
    const answer = this.answer.trim(); // Trim whitespace from answer
    const language = this.data.language;
    // const classification = this.result[0].predicted_label;
    const classification = this.result[0].predicted_score >= 0.65 ? this.result[0].predicted_label : ' ';
    // const confidence_score = this.result[0].predicted_score;
    const confidence_score = this.result[0].predicted_score >= 0.65 ? this.result[0].predicted_score : 0.000001;
    let correct_answer = this.correct_answer;
    if(correct_answer){
      correct_answer = correct_answer;
    }else{
      correct_answer = " ";
    }
    if (classification != " " && correct_answer == " ") {
      correct_answer = this.result[0].predicted_label;
    }
     // Assuming result contains the correct answer
    try {
      this.globalService.logoutLoading();
      this.apiService.addClassificationInferenceData(question_guid,question,answer,language,classification,confidence_score,correct_answer).subscribe(
        async (response) => {
          // console.log("Data get successfully:", response);
          this.modalCtrl.dismiss('save');    
          // Add logic to emit or handle saved answer
          await this.globalService.dismissLoading();
          
        },
        (err) => {
          this.globalService.dismissLoading();
        }
      );







      // this.sttInferenceResult(this.data);
      // this.apiService.sttInferenceResult(this.data.guid,this.answer).subscribe(
      //   async (response) => {
      //     console.log("Data get successfully:", response);
      //     this.modalCtrl.dismiss('save');    
      //     // Add logic to emit or handle saved answer
      //     await this.globalService.dismissLoading();
          
      //   },
      //   (err) => {
      //     this.globalService.dismissLoading();
      //   }
      // );
    } catch (error) {
      console.error('Error saving answer:', error);
      // alert('Failed to save answer. Please try again.');
    }

    // sttInferenceResult


    
  }

//   retriveSTTTextList() {
//     try {
//       this.apiService.getSTTTextList(lang,this.currentPage,this.pageSize).subscribe(
//         async (response) => {
//           console.log("Data get successfully:", response);
//           this.textListData = response.data; // Assuming the API returns an array of text records
//           this.totalPages = Math.ceil(response.totalCount / Number(this.pageSize)) || 1;
//           await this.globalService.dismissLoading();
          
//         },
//         (err) => {
//           this.totalPages = 1;
//           this.textListData = [];
//           console.error("Error during API call:", err);
//           alert("Failed to save data. Please try again.");
//           this.globalService.dismissLoading();
//         }
//       );

//     } catch (error) {
//       console.error('Unexpected error while data loading:', error);
//       alert('Failed to load data. Please try again.');
//       this.globalService.dismissLoading();
//     }
// }

  closeModal(target:string) {
      this.modalCtrl.dismiss(target);    
    }
  }
